import { Tensor } from "onnxruntime-web";

export function file2Image(file: File) {
  return new Promise<HTMLImageElement>((resolve) => {
    const reader = new FileReader();
    reader.onload = function (event) {
      const img = new Image();
      img.onload = function () {
        resolve(img);
      };
      img.src = event.target!.result as string; // This triggers img.onload
    };
    reader.readAsDataURL(file);
  });
}

export function calculateResizedDimensions(
  sourceSize: { width: number; height: number },
  targetSize: { width: number; height: number },
) {
  if (sourceSize.width === sourceSize.height) {
    return {
      width: targetSize.width,
      height: targetSize.height,
      offsetX: 0,
      offsetY: 0,
    };
  }
  if (sourceSize.width > sourceSize.height) {
    const targetHeight = Math.round(targetSize.width * (sourceSize.height / sourceSize.width));
    return {
      width: targetSize.width,
      height: targetHeight,
      offsetX: 0,
      offsetY: (targetSize.height - targetHeight) / 2,
    };
  }
  const targetWidth = Math.round(targetSize.height * (sourceSize.width / sourceSize.height));
  return {
    width: targetWidth,
    height: targetSize.height,
    offsetX: (targetSize.width - targetWidth) / 2,
    offsetY: 0,
  };
}

export function imageData2Tensor(imageData: ImageData) {
  // 1. Get buffer data from image and create R, G, and B arrays.
  const [redArray, greenArray, blueArray]: [number[], number[], number[]] = [[], [], []];

  const imageBufferData = imageData.data;
  // 2. Loop through the image buffer and extract the R, G, and B channels
  for (let i = 0; i < imageBufferData.length; i += 4) {
    redArray.push(imageBufferData[i]);
    greenArray.push(imageBufferData[i + 1]);
    blueArray.push(imageBufferData[i + 2]);
  }

  // width then height or the other way around? it's square so rn order doesn't matter
  const dims = [1, 3, imageData.width, imageData.height];

  // 3. Concatenate RGB to transpose [224, 224, 3] -> [3, 224, 224] to a number array
  const transposedData = redArray.concat(greenArray).concat(blueArray);

  // 4. convert to float32
  const l = transposedData.length; // length, we need this for the loop
  // create the Float32Array size 3 * 224 * 224 for these dimensions output
  const float32Data = new Float32Array(dims[1] * dims[2] * dims[3]);
  for (let i = 0; i < l; i++) {
    float32Data[i] = transposedData[i] / 255.0; // convert to float
  }
  // 5. create the tensor object from onnxruntime-web.
  return new Tensor("float32", float32Data, dims);
}

export function cropImage(
  image: HTMLImageElement | HTMLCanvasElement,
  cropDimensions: { left: number; top: number; width: number; height: number },
) {
  const canvas = document.createElement("canvas");
  // const canvas: HTMLCanvasElement = document.getElementById("test")! as HTMLCanvasElement;
  // console.log(`Cropped size: ${cropDimensions.width}x${cropDimensions.height}`);
  canvas.width = cropDimensions.width;
  canvas.height = cropDimensions.height;
  const ctx = canvas.getContext("2d")!;
  ctx.drawImage(
    image,
    cropDimensions.left,
    cropDimensions.top,
    cropDimensions.width,
    cropDimensions.height,
    0,
    0,
    cropDimensions.width,
    cropDimensions.height,
  );
  return canvas;
}
